module.exports = __webpack_public_path__ + "static/img/5019_phase_function_Paper_Points.01a85e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5019_phase_function_Paper_Points.png
// module id = 2n6m
// module chunks = 0